import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import { useSelector } from 'react-redux';
import { BULGARIAN_VENUE_IDS, EUR_TO_BGN_CONVERSION_RATE } from '../../appConstants';
import { getVenueId } from '../../selectors/root';

export const PRICE_CONTEXT_PAYMENT_CTA = 'payment_cta';
export const PRICE_CONTEXT_MENU_ITEM = 'menu_item';
export const PRICE_CONTEXT_PRODUCT_DETAILS = 'product_details';
export const PRICE_CONTEXT_CHECKOUT_MODAL_SUBTOTAL = 'checkout_modal_subtotal';

const FormattedPrice = ({ value, showCurrency, context }, { currency }) => {
  const venueId = useSelector(getVenueId);

  const options = {
    // Indonesian rupiah should be displayed without the decimal places.
    // Sen are obsolete subunits (no longer produced) and displaying prices with
    // .00 decimals looks strange in Indonesia.
    ...(currency === 'IDR' ? { maximumFractionDigits: 0 } : {}),
  };

  if (!showCurrency) {
    // eslint-disable-next-line react/style-prop-object
    return <FormattedNumber style="decimal" value={value / 100} {...options} />;
  }

  if (currency === 'BGN' || (currency === 'EUR' && BULGARIAN_VENUE_IDS.includes(venueId))) {
    const alternateCurrency = currency === 'EUR' ? 'BGN' : 'EUR';
    const alternateValue = Math.round(
      currency === 'EUR' ? value * EUR_TO_BGN_CONVERSION_RATE : value / EUR_TO_BGN_CONVERSION_RATE
    );

    const showConversionRate = [
      PRICE_CONTEXT_PAYMENT_CTA,
      PRICE_CONTEXT_MENU_ITEM,
      PRICE_CONTEXT_PRODUCT_DETAILS,
      PRICE_CONTEXT_CHECKOUT_MODAL_SUBTOTAL,
    ].includes(context);

    return (
      <span>
        {/* eslint-disable-next-line react/style-prop-object */}
        <FormattedNumber style="currency" currency={currency} value={value / 100} {...options} /> /{' '}
        <FormattedNumber
          /* eslint-disable-next-line react/style-prop-object */
          style="currency"
          currency={alternateCurrency}
          value={alternateValue / 100}
          {...options}
        />
        {showConversionRate && <> (€1 = BGN {EUR_TO_BGN_CONVERSION_RATE})</>}
      </span>
    );
  }

  // eslint-disable-next-line react/style-prop-object
  return <FormattedNumber style="currency" currency={currency} value={value / 100} {...options} />;
};

FormattedPrice.defaultProps = {
  showCurrency: true,
  context: undefined,
};

FormattedPrice.propTypes = {
  value: PropTypes.number,
  showCurrency: PropTypes.bool,
  context: PropTypes.string,
};

FormattedPrice.contextTypes = {
  currency: PropTypes.string,
};

export default FormattedPrice;
